import React from 'react';
import PropTypes from 'prop-types';

import { useStyles } from '~/assets/styles';
import SwitchFormik from '~/components/core/Formik/SwitchFormik';
import { TrashIcon } from '~/components/icons';
import InlineIconButton from '~/components/InlineIconButton';
import cn from '~/Utils/cn';

// Key auto-fill from the display name lives on the display-name field's onChange in
// ArrayFieldFormik (edit-driven), so a reorder can't rewrite the key.
const SwitchOrDelete = ({ id, isExistingValue, onDelete, ...rest }) => {
  const { classes } = useStyles();

  if (!isExistingValue) {
    return (
      <div className="flex items-center justify-center p-16">
        <InlineIconButton
          icon={TrashIcon}
          tooltipTitle="Remove"
          iconStyle={{ display: 'flex' }}
          className={cn(classes.textIcon, classes.hoverableNonFilledIcon)}
          onClick={onDelete}
          hideErrorGap
          {...rest}
        />
      </div>
    );
  }

  return <SwitchFormik id={id} labelStyle={{ margin: '10px 0 0 0' }} {...rest} />;
};

SwitchOrDelete.propTypes = {
  id: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
  isExistingValue: PropTypes.bool.isRequired,
};

export default SwitchOrDelete;
